import { render, staticRenderFns } from "./JcdcDualListBox.vue?vue&type=template&id=23d8a969"
import script from "./JcdcDualListBox.vue?vue&type=script&lang=ts"
export * from "./JcdcDualListBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports